import { useContext, useEffect, useState } from "react";
import logo from "../img/logo.jpeg";
import {DataContext} from '../context/DataContext'
import Select from 'react-select'
import {petitions} from '../api/calls.js'
import { toast } from 'sonner'
import {useNavigate } from 'react-router-dom';
import customStyles_v2 from "../frontend/styles/select_v2.js";

export default function SelectCompany() {
  const {user,saveEmpresa} = useContext(DataContext)
  const [options, setOptions] = useState([])
  const [idEmpresa, setIdEmpresa] = useState("")

  const navigate = useNavigate();

  useEffect(() => {
    const fetchEmpresas = async () => {
      var obj = JSON.parse(localStorage.getItem("session"))
      const response = await petitions.getEmpresas(obj.idUsuario, obj.token)

      if (response.status === "success") {
        var array = response.data.map(e => ({
          value: e.idEmpresa, 
          label: e.rSocial
        }))
        setOptions(array)
      } else {
        var msg = typeof response.code === "string" ? response.message : response.data
        toast.error(msg)
      }
    }

    fetchEmpresas()
  }, [])

  const saveCompany = () => {
    localStorage.setItem("empresa",JSON.stringify(idEmpresa))
    const obj = localStorage.getItem("session");
    if (obj) {
      var session = JSON.parse(obj);
      saveEmpresa(idEmpresa.value,session.token)
      navigate('/main', { replace: true })
    }
    else{
      navigate('/', { replace: true })
    }
  }

  return (
    <>
      <main className="main" id="top">
        <div className="container">
          <div className="row flex-center min-vh-100 py-5">
            <div className="col-sm-10 col-md-8 col-lg-5 col-xl-5 col-xxl-3">
              <div className="text-center mb-5">
                <div className="avatar avatar-4xl mb-4">
                  <img
                    className="rounded-circle"
                    src={logo}
                    alt=""
                  />
                </div>
                <h2 className="text-body-highlight">
                  {" "}
                  <span className="fw-normal">Hola </span>{user.nombres + " " + user.apellidos}
                </h2>
                <p className="text-body-tertiary">
                  Elige la empresa a la cual deseas ingresar
                </p>
              </div>
              <Select
                className="mi-select"
                classNamePrefix="rs"
                placeholder="Selecciona una empresa"
                styles={customStyles_v2}
                options={options}
                onChange={(event) => {
                  setIdEmpresa(event)
                }}
              />
              <br />
              <button className="btn btn-primary w-100 rounded-4" type="button" disabled={idEmpresa.length === 0 ? true:false} onClick={saveCompany}>
                Entrar
              </button>
            </div>
          </div>
        </div>
      </main>
    </>
  );
}


